import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { meetingApi } from "@store/api/meeting";
import { clearMeetingState } from "@store/meetingSlice";
import { getMeetingLiveToolsFromPayload } from "@store/utils/meetingPayload";

const initialState = {
  isSidebarOpen: false,
  tabIndex: 0,
  participantView: "avatar",
  profile: {},
  isProfileOverlayOpen: false,
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
      if (!state.isSidebarOpen) {
        state.isProfileOverlayOpen = false;
      }
    },
    toggleParticipantView: (state, action) => {
      state.participantView = action.payload;
    },
    toggleTabIndex: (state, action) => {
      state.tabIndex = action.payload;
    },
    loadProfile: (state, action) => {
      state.profile = action.payload;
    },
    openSidebar: (state) => {
      state.isSidebarOpen = true;
    },
    openProfileOverlay: (state) => {
      state.isProfileOverlayOpen = true;
    },
    closeProfileOverlay: (state) => {
      state.isProfileOverlayOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearMeetingState, (state) => {
      state.isProfileOverlayOpen = false;
    });
    builder.addMatcher(
      isAnyOf(
        meetingApi.endpoints.checkExistingMeeting.matchFulfilled,
        meetingApi.endpoints.joinMeetingFromWeb.matchFulfilled,
        meetingApi.endpoints.checkWebUserLiveMeeting.matchFulfilled,
        meetingApi.endpoints.joinWebMeeting.matchFulfilled,
        meetingApi.endpoints.getActiveWebMeeting.matchFulfilled
      ),
      (state, { payload }) => {
        if (getMeetingLiveToolsFromPayload(payload).length) {
          state.isSidebarOpen = true;
          state.tabIndex = 1;
        }
      }
    );
  },
});

const { reducer, actions } = sidebarSlice;

export const {
  toggleSidebar,
  toggleParticipantView,
  toggleTabIndex,
  loadProfile,
  openSidebar,
  openProfileOverlay,
  closeProfileOverlay,
} = actions;

export default reducer;
